import React, { useState, useEffect } from "react";
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";
import ReactSearchBox from "react-search-box";
import "./style.css";
import useAdminBatchDetailsGet from "../../../api-definition/useAdminBatchDetailsGet";
import useAdminUserBatchInfo from "../../../api-definition/useAdminUserBatchInfo";
import { getCookie } from "../../../utils/cookieUtils";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";

function UploadFolderModal(props) {
  const [batchPaths, setPaths] = useState([]);
  const [currentPath, setCurrentPath] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [isErrorModalOpen, setIsErrorModalOpen] = useState(false);

  const handleInputChange = (event) => {
    setCurrentPath(event.target.value);
  };

  const handleAddPath = () => {
    if (currentPath.trim() !== "") {
      setPaths([...batchPaths, currentPath]);
      setCurrentPath("");
    }
  };

  const handleSubmit = () => {
    console.log(batchPaths);
    const data = {
      batch_path: batchPaths,
    };

    fetch(`${process.env.REACT_APP_API_URL}/percept_db/v1/file-path-upload`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Spl-Username-Header": getCookie("X-Spl-Username-Header"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.ok) {
          console.log("Folders uploaded successfully");
        } else {
          response.json().then((errorMessage) => {
            setErrorMessage(errorMessage.error.message);
            setIsErrorModalOpen(true);
          });
        }
      })
      .catch((error) => {
        setErrorMessage(error);
        setIsErrorModalOpen(true);
      });

    props.onClose();
  };

  const closeErrorModal = () => {
    setIsErrorModalOpen(false);
    setErrorMessage("");
  };

  return (
    <div>
      <Dialog open={props.open} onClose={props.onClose}>
        <DialogTitle>Upload Folder</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Folder Path"
            fullWidth
            value={currentPath}
            onChange={handleInputChange}
          />
          <ul>
            {batchPaths.map((path, index) => (
              <li key={index}>{path}</li>
            ))}
          </ul>
        </DialogContent>
        <DialogActions>
          <Button onClick={props.onClose}>Cancel</Button>
          <Button onClick={handleAddPath}>Add Path</Button>
          <Button onClick={handleSubmit}>Submit</Button>
        </DialogActions>
      </Dialog>

      {/* Error modal */}
      <Dialog open={isErrorModalOpen} onClose={closeErrorModal}>
        <DialogContent>
          <p className="error-title">Error</p>
          <p>{errorMessage}</p>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeErrorModal}>Close</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

function ViewModal({
  open,
  onClose,
  batch,
  batchInstructions,
  batchInstructionsList,
}) {
  const [addModalOpen, setAddModalOpen] = useState(false);

  const handleEditClick = () => {
    setAddModalOpen(true);
    onClose();
  };

  const handleAddClose = () => {
    setAddModalOpen(false);
  };

  if (addModalOpen) {
    return (
      <AddModal
        open={true}
        onClose={handleAddClose}
        batch={batch}
        batchInstructions={batchInstructions}
        batchInstructionsList={batchInstructionsList}
      />
    );
  } else {
    return (
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>{batch && batch.bname}</DialogTitle>
        <DialogContent>
          <p>
            <div className="view">
              <b>Batch Name: </b>
              {batch && batch.bname}
            </div>
            <div clasName="view">
              <b>Users Added: </b>
              {batch && batch.usersAdded.join(", ")}
            </div>
            <div className="view">
              <b>Users Statuses: </b>
              <div className="user-list-container">
                <ul className="user-list">
                  {batch &&
                    Object.entries(batch.usersStatus).map(
                      ([user, progress]) => (
                        <li>
                          <b>{user}</b>: <span>{progress}</span>
                        </li>
                      )
                    )}
                </ul>
              </div>
            </div>
            <div className="view">
              <b>Batch Instructions: </b> {batch && batch.batchInstructions}
            </div>
            <div className="view">
              <b>No of users: </b>
              {batch && batch.noOfUsers}
            </div>
            <div className="view">
              <b>Randomized File Playback: </b>
              {(batch && batch.randomizeFilePlayback) == true ? "Yes" : "No"}
            </div>
            <div className="view">
              <b>File Multi Assign (in %): </b>
              {batch && batch.fileMultiSign}
            </div>
          </p>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleEditClick}>Edit</Button>
          <Button onClick={onClose}>Close</Button>
        </DialogActions>
      </Dialog>
    );
  }
}

function AddModal({
  open,
  onClose,
  batch,
  batchInstructions,
  batchInstructionsList,
}) {
  const [userInput, setUserInput] = useState("");
  const [selectedUsers, setSelectedUsers] = useState(
    batch && batch.usersAdded && batch.usersAdded.length > 0
      ? batch.usersAdded
      : []
  );

  const [selectedInstructions, setSelectedInstructions] = useState(
    batch && batch.batchInstructions ? batch.batchInstructions : ""
  );

  const handleAddUser = () => {
    const usersToAdd = userInput
      .split(",") // Split input value by commas
      .map((u) => u.trim()) // Trim each user value
      .filter((u) => u); // Filter out empty values
    if (!selectedUsers.includes(userInput.trim())) {
      setSelectedUsers([...selectedUsers, ...usersToAdd]); // Add users to the selectedUsers list
      setUserInput(""); // Reset the input value
    }
  };

  const handleRemoveUser = (user) => {
    setSelectedUsers(selectedUsers.filter((u) => u !== user));
  };

  const handleAddInstruction = (instruction) => {
    if (!selectedInstructions) {
      setSelectedInstructions(instruction);
    } else {
      setSelectedInstructions(instruction);
    }
  };

  const handleRemoveInstruction = () => {
    setSelectedInstructions("");
  };

  const [fileMultiassignPercentage, setFileMultiassignPercentage] = useState(
    batch && batch.fileMultiSign ? batch.fileMultiSign : ""
  );

  const [randomizeFilePlayback, setRandomizeFilePlayback] = useState(true);

  const handleAssign = () => {
    // Use the spread operator to copy the current batch object
    const updatedBatch = { ...batch };
    // Update the fileMultiSign property with the new value
    updatedBatch.fileMultiSign = fileMultiassignPercentage;
    // Update the randomizeFilePlayback property with the new value
    updatedBatch.randomizeFilePlayback = randomizeFilePlayback;
    // Create the data object with the updated batch object
    const data = {
      batch_id: updatedBatch.batchId,
      batch_name: updatedBatch.bname,
      users_list: selectedUsers,
      batch_instruction: selectedInstructions,
      randomize_file_playback: updatedBatch.randomizeFilePlayback,
      file_multiassign_percentage: updatedBatch.fileMultiSign,
    };

    fetch(`${process.env.REACT_APP_API_URL}/percept_db/v1/manage-user-batches`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Spl-Username-Header": getCookie("X-Spl-Username-Header"),
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Success!");
        onClose();
      })
      .catch((error) => {
        console.error("Excepted!");
      });
    setSelectedUsers([]);
  };

  function handleSpinboxChange(e) {
    const newValue = e.target.value;
    setFileMultiassignPercentage(newValue);
  }

  function handleCheckboxChange(e) {
    const newValue = e.target.checked;
    setRandomizeFilePlayback(newValue);
  }

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Add Modal</DialogTitle>
      <DialogContent>
        <div>
          <b>Batch Name: </b> {batch && batch.bname}
        </div>
        <div>
          <label htmlFor="users">
            <b>Enter Users (separated by commas):</b>
          </label>
          <div style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
            <input
              type="text"
              id="users"
              value={userInput}
              onChange={(e) => setUserInput(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleAddUser();
                }
              }}
              style={{ width: "200px" }}
            />
            <button onClick={handleAddUser}>Add User</button>
          </div>
        </div>

        <div>
          <label htmlFor="instructions">
            <b>Select an Instruction: </b>
          </label>
          <select
            id="instructions"
            onChange={(e) => handleAddInstruction(e.target.value)}
          >
            <option value="">Select an instruction</option>
            {[
              ...batchInstructionsList.filter((instruction) => instruction), // filter out empty or undefined instructions
            ].map((instruction) => (
              <option
                key={instruction}
                value={instruction}
                title={instruction}
                selected={instruction === selectedInstructions}
              >
                {instruction}
              </option>
            ))}
          </select>
        </div>

        <div>
          <p>
            <b>Selected Users: </b>
          </p>
          <ul>
            {selectedUsers.map((user) => (
              <li key={user}>
                {user}{" "}
                <button onClick={() => handleRemoveUser(user)}>Remove</button>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p>
            <b>Selected Instructions: </b>
          </p>
          <ul>
            {selectedInstructions && (
              <li>
                {selectedInstructions}{" "}
                <button onClick={() => handleRemoveInstruction()}>
                  Remove
                </button>
              </li>
            )}
          </ul>
        </div>
        <div>
          <label htmlFor="spinbox1">
            <b>File multi-assign (in %) : </b>
          </label>
          <input
            type="number"
            id="spinbox1"
            name="spinbox1"
            min="0"
            max="10"
            step="1"
            defaultValue={batch && batch.fileMultiSign}
            onChange={handleSpinboxChange}
          />
        </div>

        <div>
          <input
            type="checkbox"
            id="checkbox2"
            name="checkbox2"
            defaultChecked={batch && batch.randomizeFilePlayback ? false : true}
            onChange={handleCheckboxChange}
          />
          <label htmlFor="checkbox2"> Randomize File Playback</label>
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleAssign}>Assign</Button>

        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
}

function Admin(props) {
  const {
    batchId,
    batchNames,
    spreadsheetLink,
    study,
    noOfUsers,
    status,
    fileUploadStatus,
    usersAdded,
    usersStatus,
    batchInstructions,
    batchInstructionsList,
    randomizeFilePlayback,
    fileMultiSign,
  } = useAdminBatchDetailsGet(props);
  const {
    userName,
    batchesAssigned,
    studiesRemaining,
    batchesCompleted,
    completionDate,
    userNameBatchDetails,
  } = useAdminUserBatchInfo(props);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchUserQuery, setSearchUserQuery] = useState("");
  const [searchUserBatchQuery, setSearchUserBatchQuery] = useState("");
  const [files, setFiles] = useState([]);
  const [batchData, setBatchData] = useState([]);
  const [userData, setUserData] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedUserData, setSelectedUserData] = useState([]);
  const [searchBatchQuery, setSearchBatchQuery] = useState("");
  const [viewModalOpen, setViewModalOpen] = useState(false);
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [notificationMessage, setNotificationMessage] = useState("");
  const [batchList, setBatchList] = useState([]);

  useEffect(() => {
    if (batchNames) {
      const data = batchNames.map((bname, index) => ({
        id: index + 1,
        batchId: batchId[index] || "",
        bname: bname,
        spreadsheetLink: spreadsheetLink[index] || "",
        study: study[index] || "",
        noOfUsers: noOfUsers[index] || "",
        status: status[index] || "",
        fileUploadStatus: fileUploadStatus[index] || "",
        usersAdded: usersAdded[index] || [],
        usersStatus: usersStatus[index] || {},
        batchInstructions: batchInstructions[index] || "",
        batchInstructionsList: batchInstructionsList[index] || [],
        randomizeFilePlayback: randomizeFilePlayback[index] || "",
        fileMultiSign: fileMultiSign[index] || "",
      }));
      setBatchData(data);
    } else {
      setBatchData([]);
    }
  }, [
    batchId,
    batchNames,
    study,
    spreadsheetLink,
    noOfUsers,
    status,
    fileUploadStatus,
    usersAdded,
    usersStatus,
    batchInstructions,
    batchInstructionsList,
    randomizeFilePlayback,
    fileMultiSign,
  ]);

  useEffect(() => {
    if (userName) {
      const data = userName.map((uname, index) => ({
        id: index + 1,
        username: uname,
        batchesAssigned: batchesAssigned[index] || "",
        studiesRemaining: studiesRemaining[index] || [],
        batchesCompleted: batchesCompleted[index] || "",
        completionDate: completionDate[index] || "",
      }));
      setUserData(data);
    } else {
      setUserData([]);
    }
  }, [
    userName,
    batchesAssigned,
    studiesRemaining,
    batchesCompleted,
    completionDate,
  ]);

  const handleBatchSearch = (query) => {
    setSearchQuery(query);
  };

  const handleUserSearch = (userQuery) => {
    setSearchUserQuery(userQuery);
  };

  const handleFileUpload = (acceptedFiles) => {
    setFiles(acceptedFiles);
    console.log(acceptedFiles);
  };

  const filteredBatchData = batchData.filter((item) => {
    const batchIds = item.batchId.toString().toLowerCase();
    const itemName = item.bname.toString().toLowerCase();
    const itemStudy = item.study.toString().toLowerCase();
    const itemSheet = item.spreadsheetLink.toString().toLowerCase();
    const itemUsers = item.noOfUsers.toString().toLowerCase();
    const itemStatus = item.status.toLowerCase();
    const itemUploadStatus = item.fileUploadStatus.toLowerCase();
    const query = searchQuery.toLowerCase();
    return (
      batchIds.includes(query) ||
      itemName.includes(query) ||
      itemStudy.includes(query)||
      itemSheet.includes(query) ||
      itemUsers.includes(query) ||
      itemStatus.includes(query) ||
      itemUploadStatus.includes(query)
    );
  });

  const filteredUserData = userData.filter((item) => {
    const itemUname = item.username.toString().toLowerCase();
    const itemBatchedAssigned = item.batchesAssigned.toString().toLowerCase();
    const itemStudiesRemaining = item.studiesRemaining.toString().toLowerCase();
    const itemBatchesCompleted = item.batchesCompleted.toString().toLowerCase();
    const itemDateCompleted = item.completionDate.toString().toLowerCase();
    const userQuery = searchUserQuery.toLowerCase();
    return (
      itemUname.includes(userQuery) ||
      itemBatchedAssigned.includes(userQuery) ||
      itemStudiesRemaining.includes(userQuery) ||
      itemBatchesCompleted.includes(userQuery) ||
      itemDateCompleted.includes(userQuery)
    );
  });

  const [toggleOn, setToggleOn] = useState(false);
  const toggleHandler = () => {
    setToggleOn(!toggleOn);
    if (!toggleOn) {
      setSearchQuery("");
      setSearchUserQuery("");
      setSearchUserBatchQuery("");
    }
  };

  const getUserBatchDetails = (user) => {
    if (user === "") {
      // return all batch details if user is not selected
      return userNameBatchDetails.map((u) => u.batchDetails).flat();
    }
    const foundUser = userNameBatchDetails.find((u) => u.user === user);
    if (foundUser) {
      return foundUser.batchDetails;
    }
    return null; // or you can return an empty array []
  };

  const handleOptionChange = (event) => {
    const selectedUser = event.target.value;
    setSelectedOption(selectedUser);
  };

  useEffect(() => {
    if (toggleOn) {
      const userData = getUserBatchDetails(selectedOption);
      if (userData) {
        setSelectedUserData(userData);
      } else {
        setSelectedUserData([]);
      }
    } else {
      const userData = getUserBatchDetails(selectedOption);
      if (userData) {
        const filteredData = userData.filter(
          (item) =>
            item.batchName
              .toLowerCase()
              .includes(searchBatchQuery.toLowerCase()) ||
            item.recentlyRatedFile
              .toLowerCase()
              .includes(searchBatchQuery.toLowerCase()) ||
            item.lastAccessTime
              .toLowerCase()
              .includes(searchBatchQuery.toLowerCase()) ||
            item.completionStatus
              .toLowerCase()
              .includes(searchBatchQuery.toLowerCase())
        );
        setSelectedUserData(filteredData);
      } else {
        setSelectedUserData([]);
      }
    }
  }, [selectedOption, searchBatchQuery, toggleOn]);

  const handleUserBatchSearch = (value) => {
    setSearchUserBatchQuery(value);
    if (value === "") {
      // if search query is empty, display all data
      const userData = getUserBatchDetails(selectedOption);
      if (userData) {
        setSelectedUserData(userData);
      } else {
        setSelectedUserData([]);
      }
    } else {
      // filter the data based on search query
      const filteredData = selectedUserData.filter((item) => {
        const checkLAT =
          item.lastAccessTime === null ? "" : item.lastAccessTime;
        return (
          item.batchId.toLowerCase().includes(value.toLowerCase()) ||
          item.batchName.toLowerCase().includes(value.toLowerCase()) ||
          item.recentlyRatedFile.toLowerCase().includes(value.toLowerCase()) ||
          item.completionStatus.toLowerCase().includes(value.toLowerCase()) ||
          checkLAT.toLowerCase().includes(value.toLowerCase())
        );
      });
      setSelectedUserData(filteredData);
    }
  };

  const [open, setOpen] = useState(false);
  const [modalKey, setModalKey] = useState(0);

  const handleOpen = () => {
    setModalKey(modalKey + 1);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleViewModalOpen = (batch, index) => {
    setSelectedBatch(batch);
    setViewModalOpen(true);
    setBatchList(batch.batchInstructionsList);
  };

  const handleAddModalOpen = (batch, index) => {
    setSelectedBatch(batch);
    setAddModalOpen(true);
    setBatchList(batch.batchInstructionsList);
  };

  const handleModalClose = () => {
    setViewModalOpen(false);
    setAddModalOpen(false);
  };

  const handleNotifyClick = async (batchId, batchName, userName) => {
    try {

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/percept_db/v1/notify`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Spl-Username-Header": getCookie("X-Spl-Username-Header"),
          },
          body: JSON.stringify({
            user_name: userName,
            batch_name: batchName,
            batch_id: batchId,
          }),
        }
      );
      if (!response.ok) {
        setNotificationMessage("Failed to invoke notify call.");
        setTimeout(() => {
          setNotificationMessage("");
        }, 3000);
        throw new Error("Failed to invoke notify call.");
      }

      setNotificationMessage("Successfully notified!");
      setTimeout(() => {
        setNotificationMessage("");
      }, 3000);
    } catch (error) {
      console.log(error); // handle error response
    }
  };

  const handleDownloadFile = async (filePath) => {
    try {
      let filename = filePath.split("\\");
      filename = filename[filename.length - 1];
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/percept_db/v1/download-file/` + filename,
        {
          headers: {
            "X-Spl-Username-Header": getCookie("X-Spl-Username-Header"),
          },
        }
      );
      if (!response.ok) {
        throw new Error("File download failed");
      }
      const blobData = await response.blob();
      const fileUrl = URL.createObjectURL(blobData);
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = filename;
      link.click();
      URL.revokeObjectURL(fileUrl);
    } catch (error) {
      console.log(error);
    }
  };

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(25);

  const startIndex = (currentPage - 1) * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;

  const numPages = Math.ceil(filteredBatchData.length / rowsPerPage);
  const firstPage = Math.max(currentPage - 2, 1);
  const lastPage = Math.min(firstPage + 4, numPages);

  const [currentPage1, setCurrentPage1] = useState(1);
  const [rowsPerPage1, setRowsPerPage1] = useState(25);

  const startIndex1 = (currentPage1 - 1) * rowsPerPage1;
  const endIndex1 = startIndex1 + rowsPerPage1;

  const numPages1 = Math.ceil(selectedUserData.length / rowsPerPage1);
  const firstPage1 = Math.max(currentPage1 - 2, 1);
  const lastPage1 = Math.min(firstPage1 + 4, numPages1);

  const [currentPage2, setCurrentPage2] = useState(1);
  const [rowsPerPage2, setRowsPerPage2] = useState(25);

  const startIndex2 = (currentPage2 - 1) * rowsPerPage2;
  const endIndex2 = startIndex2 + rowsPerPage2;

  const numPages2 = Math.ceil(filteredUserData.length / rowsPerPage2);
  const firstPage2 = Math.max(currentPage2 - 2, 1);
  const lastPage2 = Math.min(firstPage2 + 4, numPages2);

  const [sortBy, setSortBy] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");

  const handleSort = (columnName) => {
    if (sortBy === columnName) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortBy(columnName);
      setSortOrder("asc");
    }
  };

  return (
    <div>
      {toggleOn ? (
        <p>
          <div className="table-toolbar">
            <div>
              <select
                className="select-user"
                value={selectedOption}
                onChange={handleOptionChange}
              >
                <option value="">--Select User--</option>
                {userNameBatchDetails.map((user, index) => (
                  <option key={index} value={user.user}>
                    {user.user}
                  </option>
                ))}
              </select>
            </div>
            {notificationMessage && (
              <div className="notification-container">
                <p>{notificationMessage}</p>
              </div>
            )}
            <div className="search-box-container1">
              <ReactSearchBox
                placeholder="Search..."
                value={searchUserBatchQuery}
                onChange={(value) => handleUserBatchSearch(value)}
              />
            </div>
          </div>
          <div style={{ paddingRight: '0' }}>
          {/* Table Header */}
          <table className="table" style={{ margin: '0', padding: '0', tableLayout: 'fixed', width: '100%' }}>
            <colgroup>
              <col style={{ width: '20%' }} />
              <col style={{ width: '20%' }} />
              <col style={{ width: '20%' }} />
              <col style={{ width: '20%' }} />
              <col style={{ width: '20%' }} />
            </colgroup>
            <thead style={{ position: 'sticky', top: '0', zIndex: '1', backgroundColor: '#fff' }}>
                <tr>
                  <th onClick={() => handleSort("batchName")}>
                    Batch Name{" "}
                    {sortBy === "Batch Name" && sortOrder === "asc" && (
                      <FaSortUp />
                    )}
                    {sortBy === "Batch Name" && sortOrder === "desc" && (
                      <FaSortDown />
                    )}
                    {sortBy !== "Batch Name" && <FaSort />}
                  </th>
                  <th onClick={() => handleSort("recentlyRatedFile")}>
                    Recently Rated File{" "}
                    {sortBy === "Recently Rated File" &&
                      sortOrder === "asc" && <FaSortUp />}
                    {sortBy === "Recently Rated File" &&
                      sortOrder === "desc" && <FaSortDown />}
                    {sortBy !== "Recently Rated File" && <FaSort />}
                  </th>
                  <th onClick={() => handleSort("completionStatus")}>
                    Completion Status{" "}
                    {sortBy === "Completion Status" && sortOrder === "asc" && (
                      <FaSortUp />
                    )}
                    {sortBy === "Completion Status" && sortOrder === "desc" && (
                      <FaSortDown />
                    )}
                    {sortBy !== "Completion Status" && <FaSort />}
                  </th>
                  <th onClick={() => handleSort("lastAccessTime")}>
                    Last access time{" "}
                    {sortBy === "Last access time" && sortOrder === "asc" && (
                      <FaSortUp />
                    )}
                    {sortBy === "Last access time" && sortOrder === "desc" && (
                      <FaSortDown />
                    )}
                    {sortBy !== "Last access time" && <FaSort />}
                  </th>
                  <th>Send Reminder</th>
                </tr>
              </thead>
            </table>

            {/* Table Body */}
            <div
              style={{
                overflowY: "auto",
                maxHeight: "calc(50vh - 8rem - 2px)",
                paddingRight: "0",
              }}
            >
              <table
                className="table"
                style={{
                  margin: "0",
                  padding: "0",
                  tableLayout: "fixed",
                  width: "100%",
                }}
              >
                <colgroup>
                  <col style={{ width: "20%" }} />
                  <col style={{ width: "20%" }} />
                  <col style={{ width: "20%" }} />
                  <col style={{ width: "20%" }} />
                  <col style={{ width: "20%" }} />
                </colgroup>
                <tbody>
                  {selectedUserData &&
                    selectedUserData
                      .slice(startIndex1, endIndex1)
                      .sort((a, b) => {
                        if (sortBy) {
                          const keyA = a[sortBy];
                          const keyB = b[sortBy];
                          if (sortOrder === "asc") {
                            if (keyA < keyB) return -1;
                            if (keyA > keyB) return 1;
                            return 0;
                          } else {
                            if (keyA > keyB) return -1;
                            if (keyA < keyB) return 1;
                            return 0;
                          }
                        } else {
                          return 0;
                        }
                      })
                      .map((item) => (
                        <tr key={item.id}>
                          <td
                            style={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item.batchName}
                          </td>
                          <td
                            style={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item.recentlyRatedFile}
                          </td>
                          <td
                            style={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                            className={`status-${item.completionStatus.toLowerCase()}`}
                          >
                            {item.completionStatus}
                          </td>
                          <td
                            style={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {item.lastAccessTime}
                          </td>
                          <td
                            style={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            <button
                              type="button"
                              className="btn btn-primary"
                              disabled={
                                !selectedOption ||
                                item.batchesCompleted === "completed"
                              }
                              onClick={() =>
                                handleNotifyClick(
                                  item.batchId,
                                  item.batchName,
                                  selectedOption
                                )
                              }
                            >
                              {"notify"}
                            </button>
                          </td>
                        </tr>
                      ))}
                </tbody>
              </table>
            </div>
          </div>
          {/* Send Reminder */}
          <div
            className="pagination"
            style={{ marginTop: "1rem", marginBottom: "1rem" }}
          >
            <button
              disabled={currentPage1 === 1}
              onClick={() => setCurrentPage1(currentPage1 - 1)}
            >
              Previous
            </button>
            {firstPage1 > 1 && (
              <>
                <button onClick={() => setCurrentPage1(1)}>1</button>
                {firstPage1 > 2 && <span>...</span>}
              </>
            )}
            {Array.from({ length: lastPage1 - firstPage1 + 1 }).map(
              (_, index) => {
                const page1 = firstPage1 + index;
                if (
                  page1 === 1 ||
                  page1 === numPages1 ||
                  (page1 >= currentPage1 - 1 && page1 <= currentPage1 + 1) ||
                  (page1 === currentPage1 - 2 && currentPage1 >= 4) ||
                  (page1 === currentPage1 + 2 && currentPage1 <= numPages1 - 3)
                ) {
                  return (
                    <button
                      key={page1}
                      onClick={() => setCurrentPage1(page1)}
                      className={page1 === currentPage1 ? "active" : ""}
                    >
                      {page1}
                    </button>
                  );
                }
                if (page1 === 2 && currentPage1 > 4) {
                  return <span>...</span>;
                }
                if (page1 === numPages1 - 1 && currentPage1 < numPages1 - 3) {
                  return <span>...</span>;
                }
                return null;
              }
            )}
            {lastPage1 < numPages1 && (
              <>
                {lastPage1 < numPages1 - 1 && <span>...</span>}
                <button onClick={() => setCurrentPage1(numPages1)}>
                  {numPages1}
                </button>
              </>
            )}
            <button
              disabled={currentPage1 === numPages1}
              onClick={() => setCurrentPage1(currentPage1 + 1)}
            >
              Next
            </button>
          </div>
        </p>
      ) : (
        <>
          <div className="table-toolbar">
            <div className="search-box-container">
              <ReactSearchBox
                placeholder="Search..."
                value={searchQuery}
                onChange={(value) => handleBatchSearch(value)}
              />
            </div>
            <div className="file-upload-container">
              <Button variant="contained" color="primary" onClick={handleOpen}>
                Upload Folder
              </Button>
              <UploadFolderModal
                open={open}
                onClose={handleClose}
                key={modalKey}
              />
            </div>
          </div>
          <div
            style={{
              paddingRight: "0",
            }}
          >
            <table
              className="table"
              style={{
                margin: "0",
                padding: "0",
                tableLayout: "fixed",
                width: "100%",
              }}
            >
              <colgroup>
                <col style={{ width: "14%" }} />
                <col style={{ width: "14%" }} />
                <col style={{ width: "14%" }} />
                <col style={{ width: "14%" }} />
                <col style={{ width: "14%" }} />
                <col style={{ width: "14%" }} />
                <col style={{ width: "14%" }} />
              </colgroup>
              <thead>
              <tr>
                <th onClick={() => handleSort("bname")}>
                  Audio Batch Name{" "}
                  {sortBy === "Audio Batch Name" && sortOrder === "asc" && (
                    <FaSortUp />
                  )}
                  {sortBy === "Audio Batch Name" && sortOrder === "desc" && (
                    <FaSortDown />
                  )}
                  {sortBy !== "Audio Batch Name" && <FaSort />}
                </th>
                <th onClick={() => handleSort("study")}>
                  Study{" "}
                  {sortBy === "Study" && sortOrder === "asc" && (
                    <FaSortUp />
                  )}
                  {sortBy === "Study" && sortOrder === "desc" && (
                    <FaSortDown />
                  )}
                  {sortBy !== "Study" && <FaSort />}
                </th>
                <th onClick={() => handleSort("spreadsheetLink")}>
                  Spreadsheet Link{" "}
                  {sortBy === "Spreadsheet Link" && sortOrder === "asc" && (
                    <FaSortUp />
                  )}
                  {sortBy === "Spreadsheet Link" && sortOrder === "desc" && (
                    <FaSortDown />
                  )}
                  {sortBy !== "Spreadsheet Link" && <FaSort />}
                </th>
                <th onClick={() => handleSort("noOfUsers")}>
                  Number of Users{" "}
                  {sortBy === "Number of Users" && sortOrder === "asc" && (
                    <FaSortUp />
                  )}
                  {sortBy === "Number of Users" && sortOrder === "desc" && (
                    <FaSortDown />
                  )}
                  {sortBy !== "Number of Users" && <FaSort />}
                </th>
                <th onClick={() => handleSort("status")}>
                  Status{" "}
                  {sortBy === "Status" && sortOrder === "asc" && <FaSortUp />}
                  {sortBy === "Status" && sortOrder === "desc" && (
                    <FaSortDown />
                  )}
                  {sortBy !== "Status" && <FaSort />}
                </th>
                <th onClick={() => handleSort("fileUploadStatus")}>
                  File Upload Status{" "}
                  {sortBy === "File Upload Status" && sortOrder === "asc" && (
                    <FaSortUp />
                  )}
                  {sortBy === "File Upload Status" && sortOrder === "desc" && (
                    <FaSortDown />
                  )}
                  {sortBy !== "File Upload Status" && <FaSort />}
                </th>
                <th>Action</th>
              </tr>
            </thead>
            </table>

            {/* Table Body */}
            <div
              style={{
                overflowY: "auto",
                maxHeight: "calc(50vh - 8rem - 2px)",
                paddingRight: "0",
              }}
            >
              <table
                className="table"
                style={{
                  margin: "0",
                  padding: "0",
                  tableLayout: "fixed",
                  width: "100%",
                }}
              >
                <colgroup>
                <col style={{ width: "14%" }} />
                <col style={{ width: "14%" }} />
                <col style={{ width: "14%" }} />
                <col style={{ width: "14%" }} />
                <col style={{ width: "14%" }} />
                <col style={{ width: "14%" }} />
                <col style={{ width: "14%" }} />
                </colgroup>
                <tbody>
              {filteredBatchData
                .slice(startIndex, endIndex)
                .sort((a, b) => {
                  if (sortBy) {
                    const keyA = a[sortBy];
                    const keyB = b[sortBy];
                    if (sortOrder === "asc") {
                      if (keyA < keyB) return -1;
                      if (keyA > keyB) return 1;
                      return 0;
                    } else {
                      if (keyA > keyB) return -1;
                      if (keyA < keyB) return 1;
                      return 0;
                    }
                  } else {
                    return 0;
                  }
                })
                .map((item, index) => (
                  <tr key={item.id}>
                    <td>{item.bname}</td>
                    <td>{item.study}</td>
                    <td>
                      {item.spreadsheetLink ? (
                        <button
                          type="button"
                          onClick={() =>
                            handleDownloadFile(item.spreadsheetLink)
                          }
                        >
                          Download
                        </button>
                      ) : (
                        "---"
                      )}
                    </td>
                    <td>{item.noOfUsers}</td>
                    <td className={`status-${item.status.toLowerCase()}`}>
                      {item.status}
                    </td>
                    <td>{item.fileUploadStatus}</td>
                    <td>
                      {item.fileUploadStatus === "error" ||
                      item.fileUploadStatus === "queued" ? (
                        <button disabled>
                          {" "}
                          {/* Disable the button when fileUploadStatus is "error" */}
                          {item.status ? "VIEW" : "ADD"}
                        </button>
                      ) : item.status ? (
                        <button
                          onClick={() => handleViewModalOpen(item, index)}
                        >
                          VIEW
                        </button>
                      ) : (
                        <button onClick={() => handleAddModalOpen(item, index)}>
                          ADD
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
            <ViewModal
              open={viewModalOpen}
              onClose={handleModalClose}
              batch={selectedBatch}
              batchInstructions={batchInstructions}
              batchInstructionsList={batchList}
            />
            <AddModal
              open={addModalOpen}
              onClose={handleModalClose}
              batch={selectedBatch}
              batchInstructions={batchInstructions}
              batchInstructionsList={batchList}
            />
              </table>
            </div>
          </div>
          {/* Send Reminder */}
          <div
            className="pagination"
            style={{ marginTop: "1rem", marginBottom: "1rem" }}>
              <button
                disabled={currentPage === 1}
                onClick={() => setCurrentPage(currentPage - 1)}
              >
                Previous
              </button>
              {firstPage > 1 && (
                <>
                  <button onClick={() => setCurrentPage(1)}>1</button>
                  {firstPage > 2 && <span>...</span>}
                </>
              )}
              {Array.from({ length: lastPage - firstPage + 1 }).map(
                (_, index) => {
                  const page = firstPage + index;
                  if (
                    page === 1 ||
                    page === numPages ||
                    (page >= currentPage - 1 && page <= currentPage + 1) ||
                    (page === currentPage - 2 && currentPage >= 4) ||
                    (page === currentPage + 2 && currentPage <= numPages - 3)
                  ) {
                    return (
                      <button
                        key={page}
                        onClick={() => setCurrentPage(page)}
                        className={page === currentPage ? "active" : ""}
                      >
                        {page}
                      </button>
                    );
                  }
                  if (page === 2 && currentPage > 4) {
                    return <span>...</span>;
                  }
                  if (page === numPages - 1 && currentPage < numPages - 3) {
                    return <span>...</span>;
                  }
                  return null;
                }
              )}
              {lastPage < numPages && (
                <>
                  {lastPage < numPages - 1 && <span>...</span>}
                  <button onClick={() => setCurrentPage(numPages)}>
                    {numPages}
                  </button>
                </>
              )}
              <button
                disabled={currentPage === numPages}
                onClick={() => setCurrentPage(currentPage + 1)}
              >
                Next
              </button>
            </div>

          <div className="table-toolbar">
            <div className="search-box-container">
              <ReactSearchBox
                placeholder="Search..."
                value={searchUserQuery}
                onChange={(value) => handleUserSearch(value)}
              />
            </div>
          </div>



          
          <div
            style={{
              paddingRight: "0",
            }}
          >
            <table
              className="table"
              style={{
                margin: "0",
                padding: "0",
                tableLayout: "fixed",
                width: "100%",
              }}
            >
              <colgroup>
                <col style={{ width: "20%" }} />
                <col style={{ width: "20%" }} />
                <col style={{ width: "20%" }} />
                <col style={{ width: "20%" }} />
                <col style={{ width: "20%" }} />
              </colgroup>
              <thead>
              <tr>
                <th onClick={() => handleSort("username")}>
                  User{" "}
                  {sortBy === "User" && sortOrder === "asc" && <FaSortUp />}
                  {sortBy === "User" && sortOrder === "desc" && <FaSortDown />}
                  {sortBy !== "User" && <FaSort />}
                </th>
                <th onClick={() => handleSort("batchesAssigned")}>
                  Batches Assigned{" "}
                  {sortBy === "Batches Assigned" && sortOrder === "asc" && (
                    <FaSortUp />
                  )}
                  {sortBy === "Batches Assigned" && sortOrder === "desc" && (
                    <FaSortDown />
                  )}
                  {sortBy !== "Batches Assigned" && <FaSort />}
                </th>
                <th onClick={() => handleSort("studiesRemaining")}>
                  Studies Remaining{" "}
                  {sortBy === "Studies Remaining" && sortOrder === "asc" && (
                    <FaSortUp />
                  )}
                  {sortBy === "Studies Remaining" && sortOrder === "desc" && (
                    <FaSortDown />
                  )}
                  {sortBy !== "Studies Remaining" && <FaSort />}
                </th>
                <th onClick={() => handleSort("batchesCompleted")}>
                  Batches Completed{" "}
                  {sortBy === "Batches Completed" && sortOrder === "asc" && (
                    <FaSortUp />
                  )}
                  {sortBy === "Batches Completed" && sortOrder === "desc" && (
                    <FaSortDown />
                  )}
                  {sortBy !== "Batches Completed" && <FaSort />}
                </th>
                <th onClick={() => handleSort("completionDate")}>
                  Date Completed{" "}
                  {sortBy === "Date Completed" && sortOrder === "asc" && (
                    <FaSortUp />
                  )}
                  {sortBy === "Date Completed" && sortOrder === "desc" && (
                    <FaSortDown />
                  )}
                  {sortBy !== "Date Completed" && <FaSort />}
                </th>
              </tr>
            </thead>
            </table>

            {/* Table Body */}
            <div
              style={{
                overflowY: "auto",
                maxHeight: "calc(50vh - 9rem - 2px)",
                paddingRight: "0",
              }}
            >
              <table
                className="table"
                style={{
                  margin: "0",
                  padding: "0",
                  tableLayout: "fixed",
                  width: "100%",
                }}
              >
                <colgroup>
                  <col style={{ width: "20%" }} />
                  <col style={{ width: "20%" }} />
                  <col style={{ width: "20%" }} />
                  <col style={{ width: "20%" }} />
                  <col style={{ width: "20%" }} />
                </colgroup>
                <tbody>
              {filteredUserData
                .slice(startIndex2, endIndex2)
                .sort((a, b) => {
                  if (sortBy) {
                    const keyA = a[sortBy];
                    const keyB = b[sortBy];
                    if (sortOrder === "asc") {
                      if (keyA < keyB) return -1;
                      if (keyA > keyB) return 1;
                      return 0;
                    } else {
                      if (keyA > keyB) return -1;
                      if (keyA < keyB) return 1;
                      return 0;
                    }
                  } else {
                    return 0;
                  }
                })
                .map((item) => (
                  <tr key={item.id}>
                    <td>{item.username}</td>
                    <td>{item.batchesAssigned}</td>
                    <td>{item.studiesRemaining.join(', ')}</td>
                    <td
                      className={`status-${item.batchesCompleted
                        .toString()
                        .toLowerCase()}`}
                    >
                      {item.batchesCompleted}
                    </td>
                    <td>{item.completionDate}</td>
                  </tr>
                ))}
                </tbody>
              </table>
            </div>
          </div>
          {/* Send Reminder */}
          <div
            className="pagination"
            style={{ marginTop: "1rem", marginBottom: "1rem" }}
          >
              <button
                disabled={currentPage2 === 1}
                onClick={() => setCurrentPage2(currentPage2 - 1)}
              >
                Previous
              </button>
              {firstPage2 > 1 && (
                <>
                  <button onClick={() => setCurrentPage2(1)}>1</button>
                  {firstPage2 > 2 && <span>...</span>}
                </>
              )}
              {Array.from({ length: lastPage2 - firstPage2 + 1 }).map(
                (_, index) => {
                  const page2 = firstPage2 + index;
                  if (
                    page2 === 1 ||
                    page2 === numPages2 ||
                    (page2 >= currentPage2 - 1 && page2 <= currentPage2 + 1) ||
                    (page2 === currentPage2 - 2 && currentPage2 >= 4) ||
                    (page2 === currentPage2 + 2 &&
                      currentPage2 <= numPages2 - 3)
                  ) {
                    return (
                      <button
                        key={page2}
                        onClick={() => setCurrentPage2(page2)}
                        className={page2 === currentPage2 ? "active" : ""}
                      >
                        {page2}
                      </button>
                    );
                  }
                  if (page2 === 2 && currentPage2 > 4) {
                    return <span>...</span>;
                  }
                  if (page2 === numPages2 - 1 && currentPage2 < numPages2 - 3) {
                    return <span>...</span>;
                  }
                  return null;
                }
              )}
              {lastPage2 < numPages2 && (
                <>
                  {lastPage2 < numPages2 - 1 && <span>...</span>}
                  <button onClick={() => setCurrentPage2(numPages2)}>
                    {numPages2}
                  </button>
                </>
              )}
              <button
                disabled={currentPage2 === numPages2}
                onClick={() => setCurrentPage2(currentPage2 + 1)}
              >
                Next
              </button>
            </div>
        </>
      )}

      <label class="switch">
        <input type="checkbox" onClick={toggleHandler}></input>
        <span class="slider round"></span>
      </label>
    </div>
  );
}

export default Admin;
